var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DrawerBody, Typography, Alert } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { PTCDocumentCard } from './PTCDocumentCard';
import { usePTCDocumentsContext } from '../../../hooks/useContexts';
import { PTCInvoiceDocumentSkeleton, PTCInvoicesListSkeleton, } from './PTCSkeletons';
var generateDocumentList = function (documentType, documentInfo) {
    if (documentInfo && documentInfo.length > 0) {
        return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
            React.createElement(Typography, { variant: "h4", weight: "base", className: "sui-w-full" },
                documentType,
                "s"),
            React.createElement("ul", { className: "sui-list-none sui-p-0 sui-m-0" }, documentInfo.map(function (document, index) { return (React.createElement("li", { className: "sui-pb-2 sui-w-full", key: "".concat(documentType, "-").concat(index) },
                React.createElement(PTCDocumentCard, { pdfTitle: document, documentType: documentType }))); }))));
    }
    return null;
};
export var PTCDocumentDrawerBody = function (_a) {
    var _b, _c, _d;
    var invoiceResponse = _a.invoiceResponse, bectranInvoicesError = _a.bectranInvoicesError, bectranInvoicesLoaded = _a.bectranInvoicesLoaded;
    var _e = usePTCDocumentsContext(), selectedDocument = _e.selectedDocument, documentLoadingError = _e.documentLoadingError, setDocumentLoadingError = _e.setDocumentLoadingError;
    var _f = useState(null), pdfUrl = _f[0], setPdfUrl = _f[1];
    useEffect(function () {
        var objectUrl = null;
        var fetchAndConvertBlobToObjectUrl = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (selectedDocument && selectedDocument.blob) {
                    try {
                        // Convert the Blob to an object URL
                        objectUrl = URL.createObjectURL(selectedDocument.blob);
                        setPdfUrl(objectUrl);
                    }
                    catch (error) {
                        setDocumentLoadingError(true);
                    }
                }
                return [2 /*return*/];
            });
        }); };
        fetchAndConvertBlobToObjectUrl();
        // Single cleanup function that runs when the component unmounts
        // or when selectedDocument changes
        return function () {
            // Clear any previous PDF URL from state
            setPdfUrl(null);
            // Cleanup the object URL to prevent memory leaks
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [selectedDocument, setDocumentLoadingError]);
    var isDocumentResponseEmpty = (((_b = invoiceResponse === null || invoiceResponse === void 0 ? void 0 : invoiceResponse.invoices) === null || _b === void 0 ? void 0 : _b.length) || 0) === 0 &&
        (((_c = invoiceResponse === null || invoiceResponse === void 0 ? void 0 : invoiceResponse.returns) === null || _c === void 0 ? void 0 : _c.length) || 0) === 0 &&
        (((_d = invoiceResponse === null || invoiceResponse === void 0 ? void 0 : invoiceResponse.adjustments) === null || _d === void 0 ? void 0 : _d.length) || 0) === 0;
    // Content rendering logic
    var content;
    if (!bectranInvoicesLoaded) {
        content = React.createElement(PTCInvoicesListSkeleton, null);
    }
    else if (bectranInvoicesError) {
        content = (React.createElement(Alert, { status: "error", headline: "Pro Trade Credit Documents Unavailable" }, "Something went wrong on our end. Please check back later."));
    }
    else if (documentLoadingError) {
        content = (React.createElement(Alert, { status: "error", headline: selectedDocument
                ? "".concat(selectedDocument.documentType, " Unavailable")
                : 'Pro Trade Credit Documents Unavailable' }, "Something went wrong on our end. Please check back later."));
    }
    else if (selectedDocument) {
        content = (React.createElement(React.Fragment, null,
            pdfUrl ? (React.createElement("object", { data: pdfUrl, type: "application/pdf", width: "100%", height: "650px", style: { border: '1px solid #ccc', marginTop: '16px' } },
                React.createElement("p", null, "Your browser does not support PDFs. Please download the PDF by pressing the \"Download\" button below."))) : (React.createElement(PTCInvoiceDocumentSkeleton, null)),
            React.createElement(Typography, { color: "medium", className: "sui-pt-2" },
                "The information and details presented in these documents are for reference purposes only. For the most accurate, up-to-date information and for all payment processing, please refer to the official",
                ' ',
                React.createElement("span", { className: "sui-font-black" }, "Home Depot Pro Trade Credit Management Portal"),
                ".")));
    }
    else if (isDocumentResponseEmpty) {
        content = (React.createElement(Alert, { status: "info", headline: "No Documents Found" }, "No Pro Trade Credit documents are available for this order."));
    }
    else {
        content = (React.createElement(React.Fragment, null,
            generateDocumentList('Invoice', invoiceResponse === null || invoiceResponse === void 0 ? void 0 : invoiceResponse.invoices),
            generateDocumentList('Credit Memo', invoiceResponse === null || invoiceResponse === void 0 ? void 0 : invoiceResponse.returns),
            generateDocumentList('Adjustment', invoiceResponse === null || invoiceResponse === void 0 ? void 0 : invoiceResponse.adjustments)));
    }
    return React.createElement(DrawerBody, null, content);
};
